import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="w-full bg-surface px-5 py-20 sm:py-28" data-id="element-208" data-mp="3krp5n656qzqv">
      <div className="mx-auto max-w-4xl" data-id="element-209" data-mp="3fz5nrwzgtig9">
        <div className="text-center" data-id="element-210" data-mp="3fy2whny8ddzt">
          <span className="eyebrow-rule text-[11px] font-bold uppercase tracking-[0.22em] text-secondary" data-id="element-211" data-mp="3b0kr27jf9gwk">
            Recensioni verificate
          </span>
          <h2 className="mt-4 font-display text-[1.85rem] font-black leading-tight tracking-tight text-foreground sm:text-[2.6rem]" data-id="element-212" data-mp="370k9ie110pla">
            Cosa dicono le tue{' '}
            <span className="italic text-primary" data-id="element-213" data-mp="2x007h95onh20">colleghe</span>
          </h2>
        </div>

        <div className="mx-auto mt-10 grid max-w-3xl gap-5 sm:grid-cols-2" data-id="element-214" data-mp="2s2i5y3tzw441">
          {testimonials.map(item => <figure key={item.name} className="flex h-full flex-col rounded-2xl border border-foreground/10 bg-background p-6" data-id="element-215" data-mp="v9oq3o1x3o4k">
              <div className="flex gap-1.5 text-highlight" role="img" aria-label="5 stelle su 5" data-id="element-216" data-mp="qav9hmrc3h06">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-current" aria-hidden="true" data-id="element-217" data-mp="m5b4vq1grwiv" data-mpi={i} />)}
              </div>
              <blockquote className="mt-4 flex-1 font-display text-sm italic leading-relaxed text-foreground/85" data-id="element-218" data-mp="78tvv5gqytzh">
                &laquo;{item.quote}&raquo;
              </blockquote>
              <figcaption className="mt-6" data-id="element-219" data-mp="zvwh4vwex87s">
                <p className="text-xs font-bold text-foreground" data-id="element-220" data-mp="zx7sbgs6ti8x">{item.name}</p>
                <p className="text-xs text-foreground/45" data-id="element-221" data-mp="14u7pt3az1cof">{item.role}</p>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}